import React, { Component } from 'react';
import { QueryRenderer } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Button, Grid, Link, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow, Typography } from '@mui/material';
import { TablePagination } from '@mui/material';
import Add from '@mui/icons-material/Add';
import ServerError from '../ui/ServerError';
import PageTitle from '../ui/PageTitle';
import LoadingSpinner from '../ui/LoadingSpinner';
import SearchField from '../ui/SearchField';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();

const VendorCommProgramSearchQuery = graphql`
query VendorCommProgramSearchQuery ($vendorAccountId: UUID, $name: String, $first: Int, $offset: Int) {
  commprogramsearchbyname(vendoraccountid: $vendorAccountId, search: $name, first: $first, offset: $offset) {
    totalCount
    nodes {
      cpId
      programName
      programType
      description
    }
  }
}
`;

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  },
  button: {
    marginTop: 15,
    marginRight: 16,
  }
});

class VendorCommProgramSearch extends Component {
  state = {
    programName: '',
    email: '',
    page: 0,
    rowsPerPage: 10,
  };

  componentDidMount() {
    let nameSearchTerm = localStorage.getItem('vrsName');
    let emailSearchTerm = localStorage.getItem('vrsEmail');
 
    if (nameSearchTerm == null)
      nameSearchTerm = '';

    if (emailSearchTerm == null)
    emailSearchTerm = '';

    this.setState({accountName: nameSearchTerm, email: emailSearchTerm});
  }

  goTo(route) {
    localStorage.setItem('vrsName', this.state.accountName);
    localStorage.setItem('vrsEmail', this.state.email);
 
    this.props.history.push(`/${route}`);
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };


  handleChangePage = (event, page) => {
    this.setState({page: page});
  }
  
  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let theProgramSearch = '';
    if (this.state.programName !== '')
    {
      theProgramSearch = '%' + this.state.programName + '%';
    }

 
    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;
  
    let totalCount = 0;

    // Experiences for different personas...
    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedVendor()) {
      return (
        <main>
          <PageTitle title="Commissions" subtitle="Set up partner commission plans."/>

          <Grid container spacing={1} direction="row" justifyContent="flex-start">
            <Grid item xs={12}>
              <Button
                color="primary"
                variant="contained"
                style={AppBindStyles.addButtonOnSearch}
                onClick={() => {this.goTo('vendorcommprogramcreate');}}>
                <Add/> Add commission plan
              </Button>
            </Grid>
            <Grid item>
              <SearchField
                id="programName"
                label="Search by commission plan"
                value={this.state.programName}
                onChange={this.handleChange('programName')}
              />
            </Grid>
          </Grid>

          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={VendorCommProgramSearchQuery}
            variables={{vendorAccountId: abEnvironment.getUserAttribute('a_id'),
                        name: theProgramSearch,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                totalCount = props.commprogramsearchbyname.totalCount;

                let programs = props.commprogramsearchbyname.nodes;

                return ( 
                  <div className={classes.paper}>

                    <Paper >
                      <TableContainer>
                      <Table>
                          <TableHead style={AppBindStyles.tableHead}>
                              <TableRow style={AppBindStyles.tableHeadRow}>
                                  <TableCell>Commission plan</TableCell>
                                  <TableCell>Plan type</TableCell>
                                  <TableCell>Description</TableCell>
                             </TableRow>
                          </TableHead>
                          <TableBody>
                              {programs.map(n => {

                                  let aUrl = "vendorcommprogramedit?cpId=" + n.cpId;
                                  let typeDesc = '';
                                  if (n.programType === 0) {
                                    typeDesc = 'Instant rebate'
                                  } else if (n.programType === 1) {
                                    typeDesc = 'Monthly rebate'
                                  } else if (n.programType === 2) {
                                    typeDesc = 'Monthly credits'
                                  } else if (n.programType === 3) {
                                    typeDesc = 'Prepaid credits'
                                  } else if (n.programType === 4) {
                                    typeDesc = 'Referral commission'
                                  }

                                   return (
                                      <TableRow key={n.cpId}>
                                          <TableCell>
                                            <Link component="button" 
                                                  variant="body2"
                                                  className={classes.custlink}
                                                  onClick={this.goTo.bind(this, aUrl)}>
                                              {n.programName}
                                            </Link>
                                          </TableCell>
                                          <TableCell align="left">{typeDesc}</TableCell>
                                          <TableCell align="left">{n.description}</TableCell>
                                       </TableRow>
                                  );
                              })}
                          </TableBody>
                      </Table>
                      </TableContainer>
                    </Paper>
                    <div style={AppBindStyles.paginationTableFooter}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <div>
                  <Typography>Loading...</Typography>
                  <LoadingSpinner/>
                </div>
              );
            }}
          />
        </main>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}

VendorCommProgramSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(VendorCommProgramSearch);
